<template>
  <div class="hbody relative" :class="isIpad?'ipad':''">
    <el-row v-if="tip" class="text-center bgc-wt tipbox">
      <div style="margin-top:30vh;">
        <span class=" ft-size28 bold">正在打开移动端</span>
      </div>
    </el-row>
    <!-- <div class=" absolute ft-size20 fc-wt pad20 bgc-blue" style="z-index:10001;left:50%;">{{cWidth}},{{cHeight}},{{screenW}},{{screenH}},{{rap}}</div> -->
    <div class="hello flex-column" v-show="!tip">
      <topbar></topbar>
      <div class="flexson">
        <el-row class="hei100 hidden flex-column">
          <div class="flexson relative">
            <el-row>
              <router-view :isIPAD="isIpad"></router-view>
            </el-row>
          </div>
          <footerbar></footerbar>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import topbar from "./topbar";
import footerbar from "./footerbar";
export default {
  name: "home",
  components: {
    topbar,
    footerbar
  },
  data() {
    return {
      menushowhide:true,
      tip: false,
      cWidth: document.body.clientWidth,
      cHeight: document.body.clientHeight,
      screenW:screen.width,
      screenH:screen.height,
      isIpad: false,
      showTOP: true,
      rap:'',
      mobileurl:'http://www.ylybj.cn/mobile/1-home.html',
    };
  },
  beforeMount(){
    this.isIpad = this.judgeIsPC();    
    sessionStorage.setItem("isIpad",this.isIpad);
  },
  mounted() {
     window.onresize = () => {
      this.cWidth = document.body.clientWidth;
    };
    if (this.cWidth < 1200) {
      this.tip = true;
      window.open('http://www.ylybj.cn/mobile/1-home.html');
      return;
      if ("download" in document.createElement("a")) {
            //支持a标签download的浏览器
            const link = document.createElement("a"); //创建a标签
            link.style.display = "none";
            link.href = this.mobileurl;
            document.body.appendChild(link);
            link.click(); //执行下载            
          }
    } else {
      this.tip = false;
    }       
  },
  methods: {
    menuShowHide(){
      this.menushowhide =!this.menushowhide;
    },
    // 判断PC端还是ipad端
    judgeIsPC() {           
      this.rap = navigator.platform;
      let win = this.rap.indexOf("Win") ==0;
      let mac = this.rap.indexOf("Mac") ==0;
      if(win||mac){
        return false;
      }else{
        return true;        
      }
    },
    // 全屏
    fullScreen() {
      if (window.navigator.userAgent.indexOf("MSIE") < 0) {
      }
      let main = document.body;
      if (main.requestFullscreen) {
        main.requestFullscreen();
      } else if (main.mozRequestFullScreen) {
        main.mozRequestFullScreen();
      } else if (main.webkitRequestFullScreen) {
        main.webkitRequestFullScreen();
      } else if (main.msRequestFullscreen) {
        main.msRequestFullscreen();
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  },
  destroyed() {
    window.onresize = null;
  },
  watch: {
    cWidth: {
      handler(newV, oldV) {
        if (newV < 1200) {
          this.tip = true;
        } else {
          this.tip = false;
        }
      }
    },
    $route: {
      handler: function(to, oldVal) {
        if (to.name == "index") {
          this.showTOP = true;
        } else {
          this.showTOP = false;
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/index.vue